export default __webpack_public_path__ + "static/media/Paresh V. Dattani .d5f2245d.jpg";